module.exports = __webpack_public_path__ + "static/media/symptomps.46479d3b.svg";